module.exports = __webpack_public_path__ + "img/contract-status-5.e10b2d89.png";